import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import React, { useState } from "react";
import AJXLoader from "@components/AJXLoader";
import LoadError from "@components/LoadError";
import { useTranslation } from "react-i18next";
import { apiSend, getRoute } from "@services/axios";
import { Config } from "@config/config";

import { useModal } from "@components/ModalRsuiteContext";
import { DataGrid, GridColumn, LinkButton } from "rc-easyui";
import {
  loadPriceForms,
  savePrice,
  saveStopSales,
  loadStopSale,
} from "../Actions";
import { Check, Lock } from "lucide-react";

const queryClient = new QueryClient();

function RoomPricing(props) {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <LoadRoomPricing {...props} />
      </QueryClientProvider>
    </>
  );
}

export default RoomPricing;
function LoadRoomPricing(props) {
  const { t } = useTranslation();

  const load = async () => {
    const response = await apiSend(
      [
        getRoute("PRODUCT_RETRIEVE"),
        props.productId,
        "rooms",
        props.item.id,
        "pricing",
      ].join("/"),
      "get"
    );
    if (response?.data?.request?.status === true) {
      //setPricing(response?.data?.result);

      return response?.data?.result;
    }

    return [];
  };

  const { isLoading, error, data } = useQuery("repoData", () => load());
  if (isLoading) return <AJXLoader />;
  if (error) return <LoadError message={t("not_found")} />;

  if (data.length === 0) {
    return <AJXLoader />;
  }

  return <RoomRender room={data} t={t} {...props} />;
}
function RoomRender(props) {
  const t = props.t;
  const room = props.room;
  const [pricing, setPricing] = useState(room.prices);
  const paramUseModal = useModal();
  const config = new Config(t);
  const renderStopSales = (row, value, rowIndex) => {
    return (
      <div
        className="p-2"
        style={{
          backgroundColor: config.stopSalesColor(value),
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => onStopSales(row, value, rowIndex)}
      >
        {value === 0 ? (
          <Check color="white" size={15} />
        ) : (
          <Lock color="white" size={15} />
        )}
      </div>
    );
  };

  const renderButton = (row, value, rowIndex) => {
    return (
      <LinkButton
        className="m-1"
        onClick={() => priceForms(row, value, rowIndex)}
      >
        {t("edit")}
      </LinkButton>
    );
  };
  const header = [
    {
      title: "tarif_date",
      width: 10,
      align: "left",
      filed: "date",
    },
    {
      title: "availability",
      width: 10,
      align: "center",
      filed: "rooms_available",
    },
    {
      title: "base_amount",
      width: 10,
      align: "center",
      filed: "price",
      filedList: ["price"],
    },
    {
      title: "charge",
      width: 10,
      align: "center",
      filed: "charge",
      filedList: ["price"],
    },
    {
      title: "amount_traveler",
      width: 10,
      align: "center",
      filed: "amount_traveler",
      filedList: ["price"],
    },
    {
      title: "you_earn",
      width: 10,
      align: "center",
      filed: "earn",
      filedList: ["price"],
    },
    {
      title: "",
      width: 3,
      align: "center",
      filed: "is_stop_sales",
      render: renderStopSales,
    },
    {
      title: "",
      width: 5,
      align: "center",
      filed: "button",
      render: renderButton,
    },
  ];
  const priceForms = (row, value, rowIndex) => {
    loadPriceForms(
      {
        item: row,
        index: rowIndex,
        roomIndex: props.index,
      },
      paramUseModal,
      t,
      changePrice,
      "hotel"
    );
  };
  const onStopSales = (row, value, rowIndex) => {
    loadStopSale(
      {
        item: row,
        index: rowIndex,
        roomIndex: props.index,
      },
      paramUseModal,
      changeStopSales,
      t
    );
  };

  const changePrice = async (row, index, payload) => {
    let data = pricing.slice();
    if (await savePrice("hotel", props.productId, row.item.id, payload)) {
      data.splice(row.roomIndex, 1, row.item);
      updateDataGrid(data);
    }
    paramUseModal.closeModal();
  };

  const changeStopSales = async (row) => {
    row.item.is_stop_sales = await saveStopSales(props.productId, row.item);
    let data = pricing.slice();
    data.splice(row.roomIndex, 1, row.item);
    paramUseModal.closeModal();
    updateDataGrid(data);
  };

  const updateDataGrid = (data) => {
    setPricing([]);
    const timerId = setTimeout(async () => {
      setPricing(data);
    }, 10);
    return () => {
      clearTimeout(timerId);
    };
  };

  return (
    <>
      <p className="mt-1 fw-normal">{t("ho_act_Opt_TarifTxt1")}</p>
      <b>{room.meal}</b>
      <DataGrid data={pricing} style={{ height: "70vh" }}>
        {header.map((item, index) => (
          <GridColumn
            field={item.filed}
            title={t(item.title)}
            align={item.align}
            width={item.width}
            render={({ row, value, rowIndex }) => (
              <>{item.render ? item.render(row, value, rowIndex) : value}</>
            )}
          ></GridColumn>
        ))}
      </DataGrid>
    </>
  );
}
